import { Tag, Tooltip } from "antd";
import { UserOutlined } from "@ant-design/icons";
import utils from "../../../../utils/functions";

const { splitAndFirstLetterOnlyToUpperCase } = utils;

const UserDesignationCell = ({ record }) => {
  const isOther = record.designation === "OTHER";
  const label = record.designation;
  const tooltipContent = isOther
    ? record.customDesignation || "Custom designation not provided"
    : null;

  const designationTag = (
    <Tag
      icon={<UserOutlined style={{ fontSize: 12 }} />}
      color={isOther ? "magenta" : "blue"}
      style={{
        fontWeight: 500,
        display: 'inline-flex',
        alignItems: 'center',
        borderRadius: 12,
        padding: '2px 8px',
        margin: 0
      }}
    >
      {splitAndFirstLetterOnlyToUpperCase(label, "_")}
    </Tag>
  );

  return isOther ? (
    <Tooltip title={tooltipContent}>{designationTag}</Tooltip>
  ) : (
    designationTag
  );
}

export default UserDesignationCell;